import i18n from 'i18next'

/**
 * Text the server sends in English with a key next to it (the home greeting, the upgrade box).
 * English learners get the server's text as it is, so a message set in the database still shows;
 * other languages get the translation of that key, falling back to the server's text.
 */
export const serverText = (key: string | null | undefined, english: string | null | undefined): string => {
  const text = english || ''
  if (!key || (i18n.language || 'en').startsWith('en')) return text
  return i18n.exists(key) ? i18n.t(key) : text
}
